import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LogOut, Mail, Shield, Lock } from "lucide-react";
import { api } from "~/lib/api";
import { useMe } from "~/lib/auth";
import { AppShell } from "~/components/AppShell";
import { Group } from "~/components/ui/Group";
import { Row, RowSeparator } from "~/components/ui/Row";
import { IconBadge } from "~/components/ui/IconBadge";

export const Route = createFileRoute("/_authed/account/")({
  component: AccountPage,
});

function AccountPage() {
  const navigate = useNavigate();
  const { data: me } = useMe();

  async function signOut() {
    try { await api.logout(); } catch {  }
    navigate({ to: "/login" });
  }

  return (
    <AppShell>
      <div className="max-w-2xl mx-auto pt-4 sm:pt-6 lg:pt-8">
        <header className="pb-5">
          <h1 className="text-largeTitle" style={{ color: "var(--label-primary)" }}>
            Settings
          </h1>
          <div className="text-subhead mt-1" style={{ color: "var(--label-secondary)" }}>
            Account and security.
          </div>
        </header>

        <div className="space-y-5">
          <Group header="Account">
            <Row
              leading={<IconBadge tint="blue" size={28}><Mail size={15} /></IconBadge>}
              title="Email"
              detail={me?.email ?? "—"}
            />
            <RowSeparator inset={56} />
            <Row
              leading={<IconBadge tint="purple" size={28}><Shield size={15} /></IconBadge>}
              title="Role"
              detail={me?.role ? capitalize(me.role) : "—"}
            />
          </Group>

          <Group header="Security">
            <Row
              to="/account/password"
              leading={<IconBadge tint="gray" size={28}><Lock size={15} /></IconBadge>}
              title={me?.has_password ? "Change password" : "Set a password"}
            />
          </Group>

          <Group>
            <Row
              onClick={signOut}
              leading={<IconBadge tint="red" size={28}><LogOut size={15} /></IconBadge>}
              title="Sign out"
              destructive
            />
          </Group>

          <div
            className="text-center text-caption-1 pt-2"
            style={{ color: "var(--label-tertiary)" }}
          >
            SquaredIoT · v0.0.1
          </div>
        </div>
      </div>
    </AppShell>
  );
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
